import styled from 'styled-components/native';

import FlatListWithImpression from '../../FlatListWithImpression';

const CATEGORY_LIST_MARGIN_TOP = 10;

export const S = {
  ListContainer: styled.View`
    flex: 1;
  `,
  List: styled(FlatListWithImpression)`
    width: 100%;
    margin-top: ${CATEGORY_LIST_MARGIN_TOP}px;
  `,
};
